import uniqid from 'uniqid'
import './CertificationContainer.css'

const CertificationContainer = ({ cert }) => (
  <div className='project'>
    <h3>{cert.name}</h3>

    <p className='project__description'>{cert.provider}</p>
    {cert.stack && (
      <ul className='project__stack'>
        {cert.stack.map((item) => (
          <li key={uniqid()} className='project__stack-item'>
            {item}
          </li>
        ))}
      </ul>
    )}
  </div>
)

export default CertificationContainer
